import { render, staticRenderFns } from "./ElectricianSliderStudents.vue?vue&type=template&id=24e8dcd9&scoped=true&"
import script from "./ElectricianSliderStudents.vue?vue&type=script&lang=js&"
export * from "./ElectricianSliderStudents.vue?vue&type=script&lang=js&"
import style0 from "./ElectricianSliderStudents.vue?vue&type=style&index=0&id=24e8dcd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8dcd9",
  null
  
)

export default component.exports